module.exports = __webpack_public_path__ + "static/media/class.f8a9fb2b.svg";